<script setup>
import {defineProps, defineEmits} from "vue";
import LinhaDeAditivo from "./LinhaDeAditivo/LinhaDeAditivo.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
]);

const emits = defineEmits([
    "update:alteraAditivo",
]);

//==================================================================//
//======================== Altera Aditivo ==========================//
//==================================================================//

const alteraAditivo = (update) =>{
    
    emits('update:alteraAditivo',update);

};

</script>

<template>

    <div class="c-table__body">

        <LinhaDeAditivo v-for="aditivo in props?.dado?.aditivos"
            :key="aditivo.id"
            :dado="props?.dado"
            :aditivo="aditivo"
            @update:alteraAditivo="alteraAditivo"
        ></LinhaDeAditivo>

    </div>

</template>

<style scoped>

.c-table__body{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

</style>